import React, {Fragment} from 'react';
import banner1 from '../assets/images/banner.jpg';
import '../css/Banner.css';

// Front banner of a page in login page
export default class Banner extends React.Component{
  render(){
    return(
      <Fragment>
      {/* <div className="banner-style" >
        <img className="col-12 banner" src={banner1} alt="" height="100%" width="100%"/>
        <div className="banner-heading-part-one heading-part-one">
        OKAS INTRANET
            <div className="banner-subheading">
              When tables get delivered for this weekend's party.<br/>
              Open your garage remotely and close it once everything's been uploaded.
              </div>
        </div>
      </div> */}

         <div className="banner-style"  >
          
        <div className="banner-heading-part-one heading-part-one">
        OKAS INTRANET
            <div className="banner-subheading">
              When tables get delivered for this weekend's party.<br/>
              Open your garage remotely and close it once everything's been uploaded.
              </div>
        </div>
      </div>
      </Fragment>
    );
  }
}
